import { SortDir } from "../../../../../types/certificate";

export function SortIcon({ active, dir }: { active: boolean; dir: SortDir }) {
    return (
        <span style={{ display: "inline-flex", flexDirection: "column", gap: 1, marginLeft: 4, opacity: active ? 1 : 0.3 }}>
            <span style={{ fontSize: 8, lineHeight: 1, color: active && dir === "asc" ? "var(--or)" : "var(--text3)" }}>▲</span>
            <span style={{ fontSize: 8, lineHeight: 1, color: active && dir === "desc" ? "var(--or)" : "var(--text3)" }}>▼</span>
        </span>
    );
}